/**
 * @file UnitFlagsIcon.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-10-28
 * @modified 2026-10-28
 * @description One warning icon for a line whose units don't agree along the
 *              chain — order, PO, bill, invoice, cost, price (Cam, 28 Oct 2026:
 *              "flag this via an icon with tooltip explainer"). The tooltip
 *              lists each disagreement in plain words (utils/unitChain). Nothing
 *              is shown when they agree, which is nearly always.
 */

import React from 'react';
import { unitFlagsTooltip } from '../utils/unitChain';

function UnitFlagsIcon({ flags, prefix = null }) {
  const list = Array.isArray(flags) ? flags.filter(Boolean) : [];
  if (!list.length) return null;
  const title = [prefix, unitFlagsTooltip(list)].filter(Boolean).join('\n');
  return (
    <span className="material-symbols-rounded unit-flags-icon" role="img" aria-label={title} title={title}>straighten</span>
  );
}

export default UnitFlagsIcon;
